exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1GAi {\n  margin-bottom: 0.5em;\n  font-size: 16px;\n  color: #fff;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  transition: all 0.3s ease; }\n  ._1GAi:hover {\n    background-color: #323b43; }\n\n._17gW {\n  font-weight: bold;\n  background-color: rgba(223, 223, 223, 0.111); }\n\n._2DCE {\n  margin-right: 20px;\n  width: 6px;\n  background-color: rgba(0, 0, 0, 0); }\n  ._2DCE p {\n    margin: 0px; }\n\n._22UJ {\n  background-color: #F8F8F8; }\n\n._18OY {\n  display: -ms-flexbox;\n  display: flex;\n  width: 45%;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center; }\n", ""]);

// exports
exports.locals = {
	"menuItemBox": "_1GAi",
	"menuItemBoxActive": "_17gW",
	"menuItem": "_2DCE",
	"menuItemActive": "_22UJ",
	"content": "_18OY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import /"variables/";","includePaths":["/app/src/styles"]}!./src/components/SideNav/MenuItem/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import \"variables\";","includePaths":["/app/src/styles"]}!./src/components/SideNav/MenuItem/styles.scss
// module chunks = 0